import React, {useState} from 'react';
import Login2FAEmailGuard from './Login2FAEmailGuard';
import Login2FAAuthenticator from './Login2FAAuthenticator';
import Login2FAAlternateEmailGuard from './Login2FAAlternateEmailGuard';

function Login2FA(props) {
  const {session} = props;
  const {
    account_otp_enabled,
    account_email_guard_enabled,
    account_alternate_email_on,
  } = session || {};

  const enabledOTP = account_otp_enabled === true;
  const enabledEmail = account_email_guard_enabled === true;
  const enabledAltEmail = account_alternate_email_on;

  const [showAuth, setShowAuth] = useState(enabledOTP);
  const [showEmail, setShowEmail] = useState(enabledEmail);
  const [showAltEmail, setShowAltEmail] = useState(enabledAltEmail);

  function handleShowEmail(e) {
    e.preventDefault();
    setShowAuth(false);
    setShowAltEmail(false);
    setShowEmail(true);
  }

  function handleShowAuth(e) {
    e.preventDefault();
    setShowAuth(true);
    setShowAltEmail(false);
    setShowEmail(false);
  }

  function handleShowAltEmail(e) {
    e.preventDefault();
    setShowAuth(false);
    setShowAltEmail(true);
    setShowEmail(false);
  }

  if (showAuth) {
    return (
      <Login2FAAuthenticator
        session={session}
        enabledEmail={enabledEmail}
        enabledAltEmail={enabledAltEmail}
        onShowEmail={handleShowEmail}
        onShowAltEmail={handleShowAltEmail}
      />
    );
  }

  if (showEmail) {
    return (
      <Login2FAEmailGuard
        session={session}
        enabledOTP={enabledOTP}
        enabledAltEmail={enabledAltEmail}
        onShowAuth={handleShowAuth}
        onShowAltEmail={handleShowAltEmail}
      />
    );
  }

  if (showAltEmail) {
    return (
      <Login2FAAlternateEmailGuard
        session={session}
        enabledOTP={enabledOTP}
        enabledEmail={enabledEmail}
        onShowAuth={handleShowAuth}
        onShowEmail={handleShowEmail}
      />
    );
  }
}

export default Login2FA;
